import { updateItems } from '@/mocks/home';

const tagColors: Record<string, string> = {
  '最新': 'bg-primary-100/70 text-primary-700',
  '限免': 'bg-accent-100/70 text-accent-700',
  '新作': 'bg-green-100 text-green-700',
  '独家': 'bg-accent-100/70 text-accent-700',
  '活动': 'bg-primary-100/70 text-primary-700',
  '热话': 'bg-accent-100/70 text-accent-700',
  '升级': 'bg-secondary-200/70 text-secondary-800',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">
            更新快讯
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            最新漫画更新动态与平台活动，追更不迷路，精彩不错过
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="relative">
            <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-300" />
            <div className="space-y-5">
              {updateItems.map((item) => (
                <div key={item.id} className="relative flex items-start gap-5 pl-12">
                  <div className="absolute left-[15px] top-2 w-2.5 h-2.5 rounded-full bg-primary-500 ring-4 ring-background-50" />
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 flex-wrap">
                      <span className="text-xs text-foreground-400 font-mono whitespace-nowrap">
                        {item.date}
                      </span>
                      <span
                        className={`px-2 py-0.5 rounded text-[11px] font-semibold whitespace-nowrap ${
                          tagColors[item.tag] || 'bg-secondary-100/70 text-secondary-700'
                        }`}
                      >
                        {item.tag}
                      </span>
                    </div>
                    <p className="mt-1 text-sm text-foreground-800 leading-relaxed">
                      {item.title}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}